import { render, staticRenderFns } from "./fa.vue?vue&type=template&id=6020f511&scoped=true"
import script from "./fa.vue?vue&type=script&lang=js"
export * from "./fa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6020f511",
  null
  
)

export default component.exports